<template>
    <AdminComplains v-if="isAdmin" />
    <EmployeeComplains v-else/>
</template>

<script>
import AdminComplains from "./AdminComplains.vue";
import EmployeeComplains from "./EmployeeComplains.vue";

export default {
  components: {
    AdminComplains,
    EmployeeComplains,
  },
  data() {
    const user = this.$store.state.auth.user;
    return {
      isAdmin: user && user.role === "admin",
    };
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/complains/index.vue